import api from '@/api/api_geodp'

export default class CityParametersService {
  retrieveAuthorization (tenantCode) {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       tenantId: '132456798'
    //     })
    //   }, 50)
    // })

    return api.get('auth/token?tenantCode=' + tenantCode)
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/MultiTenantService.js